import { render } from "./CalendarEventDateChooser.vue?vue&type=template&id=557e615c&scoped=true"
import script from "./CalendarEventDateChooser.vue?vue&type=script&lang=ts"
export * from "./CalendarEventDateChooser.vue?vue&type=script&lang=ts"

import "./CalendarEventDateChooser.vue?vue&type=style&index=0&id=557e615c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-557e615c"

export default script